module.exports = __webpack_public_path__ + "img/review-8.92d1687d.png";